/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Style from './style';
import { Tag } from "antd";

const MultiSelect = ({
  item,
  input,
  inputName,
  withPlaceholder = true,
  data,
  placeholder,
  config,
}) => {
  const [options, setOptions] = useState(null);

  useEffect(() => {
    const opt = (input.options || [])
      .filter(opt => ((item ? item[inputName] : data[inputName]) || []).includes(opt.value));
    setOptions(opt);
  }, []);

  return options && options.length > 0 ? (
    <Style>
      {options.map(opt => (
        <Tag key={opt.label}>
          {opt.label}
        </Tag>
      ))}
    </Style>
  ) : placeholder(item || data, inputName, withPlaceholder);
};

export default MultiSelect;
